/**
 * Cron Monitor - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Light ops mode.
 */

import React from 'react';
import { Screen } from '../design/primitives';
import CronMonitor from '../components/CronMonitor';

const CronMonitorPage: React.FC = () => {
  return (
    <Screen>
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <CronMonitor />
      </div>
    </Screen>
  );
};

export default CronMonitorPage;
